import CFG from '../gameLoopConfig.json';
import {
  WORLD_WIDTH, WORLD_HEIGHT,
  ENEMY_SIZE, ELITE_SIZE, BOSS_SIZE,
  ENEMY_DAMAGE, ENEMY_SPAWN_INTERVAL, BOSS_SPAWN_INTERVAL,
} from '../../../constants';

const EC = CFG.enemies;
const BC = CFG.boss;

export function spawnEnemies(s, timestamp, elapsed, tierIdx, lastSpawnRef) {
  if (timestamp - lastSpawnRef.current < ENEMY_SPAWN_INTERVAL) return;
  if (s.tierBossAlive || s.tierBossWarning) return;

  lastSpawnRef.current = timestamp;
  const baseMaxHp  = EC.baseHpScale * (tierIdx + EC.hpTierOffset);
  const spawnCount = Math.min(EC.spawnCountMax, EC.spawnCountBase + Math.floor(elapsed / 10) * EC.spawnCountPer10s);
  const mod        = s.activeModifier;
  const eliteChance = Math.min(EC.eliteChanceMax, EC.eliteChanceBase + tierIdx * EC.eliteChancePerTier + (mod?.eliteChanceBonus ?? 0));

  for (let n = 0; n < spawnCount && s.enemies.length < CFG.maxEnemies; n++) {
    const isElite = Math.random() < eliteChance;
    const eSize   = isElite ? ELITE_SIZE : ENEMY_SIZE;
    let ex, ey;
    const edge = Math.floor(Math.random() * 3);
    if (edge === 0)      { ex = Math.random() * (WORLD_WIDTH - eSize); ey = -eSize; }
    else if (edge === 1) { ex = -eSize;       ey = Math.random() * (WORLD_HEIGHT - eSize); }
    else                 { ex = WORLD_WIDTH;  ey = Math.random() * (WORLD_HEIGHT - eSize); }

    const hpMult     = mod?.enemyHpMult ?? 1;
    const hp         = Math.round((isElite ? baseMaxHp * EC.eliteHpMult : baseMaxHp) * hpMult);
    const damageType = ['physical', 'fire', 'lightning'][tierIdx % 3];
    const tierDmgMult = 1 + tierIdx * EC.damageScalePerTier;
    const typeDmgMult = damageType !== 'physical' ? EC.fireTypeDmgMult : 1.0;
    const typeFlat    = damageType !== 'physical' ? tierIdx : 0;
    const baseDmg    = Math.round(ENEMY_DAMAGE * tierDmgMult * typeDmgMult) + typeFlat;
    const isRanged   = !isElite && tierIdx >= 5 && Math.random() < EC.rangedChance;

    s.enemies.push({
      id: s.nextEnemyId++, x: ex, y: ey, hp, maxHp: hp, tierIdx,
      isElite, isRanged,
      size:      isElite ? ELITE_SIZE : undefined,
      damage:    isElite ? baseDmg * EC.eliteDmgMult : baseDmg,
      armor:     Math.min(10, tierIdx) + (isElite ? 2 : 0) + (mod?.enemyArmorFlat ?? 0),
      critRate:  Math.min(0.25, 0.05 + tierIdx * 0.01) + (isElite ? 0.05 : 0),
      critDamage: isElite ? 1.50 : 1.30,
      damageType,
      lastShootTime: -9999,
    });
  }
}

export function spawnBoss(s, timestamp, tierIdx) {
  if (timestamp < s.nextBossSpawnAt) return;
  if (!s.tierBossAlive && !s.tierBossWarning) {
    let bx, by;
    const edge = Math.floor(Math.random() * 3);
    if (edge === 0)      { bx = Math.random() * (WORLD_WIDTH - BOSS_SIZE); by = -BOSS_SIZE; }
    else if (edge === 1) { bx = -BOSS_SIZE;   by = Math.random() * (WORLD_HEIGHT - BOSS_SIZE); }
    else                 { bx = WORLD_WIDTH;  by = Math.random() * (WORLD_HEIGHT - BOSS_SIZE); }
    const bossHp = CFG.enemies.baseHpScale * (tierIdx + 1) * BC.hpMult;
    s.enemies.push({
      id: s.nextEnemyId++, x: bx, y: by,
      hp: bossHp, maxHp: bossHp,
      isBoss: true, size: BOSS_SIZE, tierIdx: -1,
      armor:      Math.min(BC.armorMax, BC.armorBase + tierIdx * BC.armorPerTier),
      critRate:   BC.critRate,
      critDamage: BC.critDamage,
      damageType: BC.damageType,
    });
  }
  s.nextBossSpawnAt += BOSS_SPAWN_INTERVAL;
}
